module.exports = __webpack_public_path__ + "img/bagels_done.49e335d2.jpg";